import React from "react";
import PropTypes from "prop-types";
import Framework from "@beardeddevops/react.framework";
import { confirmAlert } from "react-confirm-alert";

export default class ObjectOverride extends Framework.Components.Object {
	static propTypes = {
		...super.propTypes,
		scannedCode: PropTypes.any,
		locations: PropTypes.array.isRequired,
		states: PropTypes.array.isRequired,
		kiosks: PropTypes.array,
		account: PropTypes.string,
	};

	constructor(props, model) {
		super(props, model);

		// if( this.state.pkey && !this.state.binary_id ) {
		// 	this.props.history.push(this.redirect || this.props.baseUrl || '/dashboard');
		// }
	}

	/** @param {Locations_Properties} option */
	filterLocationOptions = (option) => !option.archived;

	filterSubscribedOnlyLocations = (option) => !option.archived && option.subscription !== null;

	render() {
		return super.render();
	}
}
